import { createActionTypeObject, createObjectForStates, getUpdatedState } from "../shared/function";

export const BOOKMARK_EVENTS = {
    GET_BOOKMARK: "GET_BOOKMARK",
    ADD_BOOKMARK: "ADD_BOOKMARK",
    TAG_BOOKMARK: "TAG_BOOKMARK",
    BOOKMARK_LIST: "BOOKMARK_LIST",
    BOOKMARK_WITH_IMAGE: "BOOKMARK_WITH_IMAGE",
    RESET_BOOKMARK_EVENTS: "RESET_BOOKMARK_EVENTS",
};

export const GET_BOOKMARK = createActionTypeObject("GET_BOOKMARK");
export const ADD_BOOKMARK = createActionTypeObject("ADD_BOOKMARK");
export const TAG_BOOKMARK = createActionTypeObject("TAG_BOOKMARK");

export const defaultGetBookmark = createObjectForStates("getBookmark");
export const defaultAddBookmark = createObjectForStates("addBookmark");
export const defaultTagBookmark = createObjectForStates("tagBookmark");

export const defaultState = {
    ...defaultGetBookmark,
    ...defaultAddBookmark,
    ...defaultTagBookmark,
    bookmarkListArray: [],
    bookmarkWithImage: null,
};

const bookmarkReducer = (state = defaultState, action = {}) => {
    switch (action.event) {
        case BOOKMARK_EVENTS.GET_BOOKMARK:
            return {
                ...state,
                ...getUpdatedState("getBookmark", GET_BOOKMARK, action.type, action.payload),
            };
        case BOOKMARK_EVENTS.ADD_BOOKMARK:
            return {
                ...state,
                ...getUpdatedState("addBookmark", ADD_BOOKMARK, action.type, action.payload),
            };
        case BOOKMARK_EVENTS.TAG_BOOKMARK:
            return {
                ...state,
                ...getUpdatedState("tagBookmark", TAG_BOOKMARK, action.type, action.payload),
            };
        case BOOKMARK_EVENTS.BOOKMARK_LIST:
            return {
                ...state,
                bookmarkListArray: action.payload,
            };
        case BOOKMARK_EVENTS.BOOKMARK_WITH_IMAGE:
            return {
                ...state,
                bookmarkWithImage: action.payload,
            };
        case BOOKMARK_EVENTS.RESET_BOOKMARK_EVENTS:
            return defaultState;
        default:
            return state;
    }
};

export default bookmarkReducer;
